import { render, staticRenderFns } from "./AmountSelect.vue?vue&type=template&id=494b9565"
import script from "./AmountSelect.vue?vue&type=script&lang=js"
export * from "./AmountSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports